import moment from 'moment';
import * as Yup from 'yup';
import { ContainerStatuses, ManifestFormSteps } from './types';
import { transportTypeValues } from 'utils/transportTypes';
import { getNormalizedStringValidation } from 'views/declarations/utils/validation-utils';

export const manifestReferenceSchema = Yup.object({
    referenceId: Yup.string().nullable().required(),
});

export const transportDetailsValidationSchema = Yup.object({
    transportTypeId: Yup.number().oneOf(transportTypeValues).nullable().required(),
    meansIdentificationType: Yup.string().nullable().required(),
    meansId: Yup.string().trim().max(35, 'Value must be at most 35 characters.').nullable().required(),
    carrierOrHaulier: getNormalizedStringValidation().nullable(),
    countryOfDispatch: Yup.string().nullable().required(),
    departurePort: Yup.string().nullable().required(),
    nationalityTransportMeans: Yup.string().nullable().required(),
    customsOfficeOfPresentation: Yup.string().nullable().required(),
    vehicleRegistration: Yup.string().trim().nullable().max(35, 'Value must be at most 35 characters.'),
    departureDateTime: Yup.string().nullable(),
    arrivalDateTime: Yup.mixed()
        .transform((value) => (value === '' ? null : value))
        .nullable()
        .required('Arrival date/time is required')
        .test(
            'arrival-after-departure',
            'Arrival date/time must be after departure date/time',
            function (arrivalValue) {
                const { departureDateTime } = this.parent;
                if (arrivalValue == null || !departureDateTime) return true;
                return moment(arrivalValue).isSameOrAfter(moment(departureDateTime));
            }
        ),
    containerIndication: Yup.number()
        .oneOf([ContainerStatuses.UNACOOMPANIED, ContainerStatuses.ACCOMPANIED], 'Invalid container indication')
        .required(),
});

export const teamValidationSchema = Yup.object({
    teamId: Yup.string().nullable().required(),
});

export const manifestFormValidationSchema = Yup.object({
    [ManifestFormSteps.MANIFEST]: manifestReferenceSchema,
    [ManifestFormSteps.TRANSPORT_DETAILS]: transportDetailsValidationSchema,
    [ManifestFormSteps.TEAM]: teamValidationSchema,
});
